// Centralized brand + site constants for Corrective Motion
export const SITE = {
  brand: "Corrective Motion",
  tagline: "Move Without Pain, Perform Without Limits.",
  founder: "Anoop Gopi",
  whatsapp: "+971555657853",
  whatsappDisplay: "+971 55 565 7853",
  instagram: "correctivemotion_",
  instagramUrl: "https://instagram.com/correctivemotion_",
  location: "Train Strength & Fitness · Dubai Mall Zabeel Expansion",
  city: "Dubai, UAE",
  // New CM monogram logo (uploaded by user)
  logoUrl: "/cm/cm-logo.webp",
  // Icon-only mark (no wordmark) — used in navbar
  iconUrl: "/cm/cm-icon.webp",
  // Updated founder photo (uploaded by user)
  founderPhoto: "/cm/anoop-gopi-corrective-exercise-specialist-dubai.webp",
  // Face-consistent AI-generated trainer imagery (Anoop Gopi as the trainer)
  images: {
    hero: "/cm/corrective-motion-personal-trainer-dubai.webp",
    assessment: "/cm/movement-posture-analysis-dubai.webp",
    movementScreen: "/cm/movement-screening-dubai.webp",
    corrective: "/cm/corrective-exercise-training-dubai.webp",
    online: "/cm/online-coaching-dubai.webp",
    strength: "/cm/strength-training-dubai-mall.webp",
    method: "/cm/corrective-method-dubai.webp",
    // legacy aliases kept for safety
    training: "/cm/strength-training-dubai-mall.webp",
    transformation: "/cm/corrective-method-dubai.webp",
    mobility: "/cm/mobility-training-dubai.webp",
  },
};

export const whatsappLink = (message = "Hi Anoop, I'd like to book a consultation with Corrective Motion.") =>
  `https://wa.me/${SITE.whatsapp.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(message)}`;
